import ItemCard, { ItemCardSkeleton } from '@/components/cards/item-card';
import { useCart } from '@/contexts/cart.context';
import { useSession } from '@/contexts/session.context';
import { QUERY_PARAMS, TAX_RATE } from '@/helper/app-constants';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { Fragment, Suspense } from 'react';

function CartBodyRightDrawer() {
  const { state } = useCart();
  const router = useRouter();
  const path = usePathname();

  // const taxAmount = state.total * TAX_RATE;
  const grandTotal = state.total;
  const isCheckingOut = path === '/order/checkout';
  const searchParams = useSearchParams();
  const orderId = searchParams.get(QUERY_PARAMS.ORDER_ID);
  const { user } = useSession();
  const isAdmin = user?.admin;

  const type = searchParams.get(QUERY_PARAMS.TYPE);

  function closeSidepanelIfDrawer() {
    // close the sidepanel if the sidepanel is drawing over the main content
    if (window.innerWidth < 1024) {
      const checkbox = document.getElementById(
        'cart-drawer'
      ) as HTMLInputElement | null;
      if (checkbox) checkbox.checked = false;
    }
  }

  function handleCheckout() {
    closeSidepanelIfDrawer();
    router.push(
      '/order/checkout' +
        (!!orderId ? `?${QUERY_PARAMS.ORDER_ID}=${orderId}` : '') +
        (type ? `${orderId ? '&' : '?'}${QUERY_PARAMS.TYPE}=${type}` : '')
    );
  }

  function handleOrderMore():
    | React.MouseEventHandler<HTMLButtonElement>
    | undefined {
    return () => {
      closeSidepanelIfDrawer();
      router.push('/order' + (type ? `?${QUERY_PARAMS.TYPE}=${type}` : ''));
    };
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between mt-4">
        <h1 className="w-full text-lg text-center">Cart</h1>
        <button
          className="btn btn-sm btn-ghost btn-circle lg:hidden absolute right-4 top-4"
          onClick={closeSidepanelIfDrawer}
          aria-label="Close cart"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div className="flex flex-col">
        {state.items.map((cartItem, i) => {
          // Generate unique key based on item ID and extras
          const extrasKey =
            cartItem.selectedExtras
              ?.map((e) => `${e.name}:${e.price}`)
              .sort()
              .join('|') || 'no-extras';
          const uniqueKey = `${cartItem.item._id}-${extrasKey}-${i}`;

          return (
            <Fragment key={uniqueKey}>
              <ItemCard
                item={cartItem.item}
                mode="cart"
                readOnly={!!orderId && !isAdmin}
                cartItemExtras={cartItem.selectedExtras}
              />
            </Fragment>
          );
        })}
      </div>
      {state.loading
        ? [...Array(3)].map((_, i) => <ItemCardSkeleton key={i} />)
        : state.items.length === 0 && (
            <>
              <div className="text-center h-40 w-full flex items-center justify-center">
                <div className="italic">No items in the cart</div>
              </div>
              {isCheckingOut && (
                <button
                  className="btn btn-secondary w-fit mt-4 mx-auto"
                  onClick={() =>
                    router.push(
                      '/order' + (type ? `?${QUERY_PARAMS.TYPE}=${type}` : '')
                    )
                  }
                >
                  Order
                </button>
              )}
            </>
          )}
      {!orderId &&
        state.items.length !== 0 &&
        (isCheckingOut ? (
          <button
            className="btn btn-secondary w-fit mt-4 mx-auto"
            onClick={handleOrderMore()}
          >
            Order more
          </button>
        ) : (
          <div className="flex flex-col gap-2 mt-10">
            <div className="flex justify-between">
              <div className="font-bold">Subtotal</div>
              <div className="font-bold">${state.total.toFixed(2)}</div>
            </div>
            {/* <div className="flex justify-between">
              <div className="font-bold">GST (10%)</div>
              <div className="font-bold">${taxAmount.toFixed(2)}</div>
            </div> */}
            <div className="border-t border-gray-300 mt-2"></div>
            <div className="flex justify-between">
              <div className="font-bold text-lg">Total</div>
              <div className="font-bold text-lg">${grandTotal.toFixed(2)}</div>
            </div>
            <button
              disabled={state.items.length === 0}
              className="btn btn-primary"
              onClick={() => {
                handleCheckout();
              }}
            >
              Checkout
            </button>
          </div>
        ))}

      {orderId && isAdmin && !isCheckingOut && (
        <button
          className="btn btn-primary"
          onClick={() => {
            handleCheckout();
          }}
        >
          Continue
        </button>
      )}
    </div>
  );
}

export default function Suspended() {
  return (
    <Suspense>
      <CartBodyRightDrawer></CartBodyRightDrawer>
    </Suspense>
  );
}
